const manutencao_parametros_exame = [
  {
    path: "/parametros_do_exame",
    redirect: "",
    component: () => import("@/layout/Layout.vue"),
    meta: {
      allowedPermissions: ["parametros_exame_create"],
      breadCrumb: "Informações Acadêmicas - Manutenção de Histórico",
    },
    children: [
      {
        path: "/manutencao-parametros-do-exame",
        name: "manutencao_parametros_do_exame",
        meta: {
          allowedPermissions: ["parametros_exame_list"],
        },
        component: () => import("@/views/ParametrosDoExame/ParametrosHome.vue"),
      },
      {
        path: "/cadastrar_parametros",
        name: "cadastrar_parametros",
        meta: {
          allowedPermissions: ["parametros_exame_create"],
        },
        component: () => import("@/views/ParametrosDoExame/ParametrosCad.vue"),
      },
      {
        path: "/editar_parametros/:id",
        name: "editar_parametros",
        meta: {
          allowedPermissions: ["parametros_exame_edit"],
        },
        component: () => import("@/views/ParametrosDoExame/ParametrosEdit.vue"),
      },
    ],
  },
];

export { manutencao_parametros_exame };
